import type { Locale as locale } from 'antd/es/locale';
import type { MappingAlgorithm } from 'antd/es/theme/interface';

export type Algorithm = MappingAlgorithm;
export type Locale = locale;
export enum ThemeType {
    LIGHT = 'light',
    DARK = 'dark',
}
export enum LanguageType {
    EN_US = 'en-US',
    ZH_TW = 'zh-TW',
}

export interface ConfigRepository {
    getTheme(): ThemeType;
    setTheme(value: ThemeType): void;
}

export interface ConfigService {
    getAlgorithm(): Algorithm;
    getTheme(): ThemeType;
    toggleTheme(): ThemeType;

    getLocale(): Locale;
    getLanguage(): LanguageType;
    changeLanguage(value: LanguageType): void;

    isPwaMode(): boolean;
    isMobileMode(): boolean;
}
